import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const mutateBusinessProfile = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { profile_id, ...body } = payload;
    const { data } = await apiClient.put('/business-profiles/' + profile_id, body);
    return data;
  }

  const { data } = await apiClient.post('/business-profiles', payload);
  return data;
};

export const useMutateBusinessProfileHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const { businessProfiles } = useTranslatedMessages();
  const snackbarText = businessProfiles?.snackbars?.saved_success ?? 'Business profile saved successfully.';

  const mutation = useMutation({
    mutationFn: mutateBusinessProfile,
    onSuccess: (data, variables) => {
      dispatch(showSnackbar({ message: snackbarText }));
      queryClient.invalidateQueries({ queryKey: ['business_profiles'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (data, isEdit) => {
    mutation.mutate({ payload: data, isEdit });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
